module.exports = "<app-tabParamTache  [typeTaches]=\"typeTaches\"></app-tabParamTache>\r\n"